export const GOOGLE_MAPS_API_KEY = 'AIzaSyCcGA2XPS9EOOPTZ1Pj-uBJK2PRt65JR5E';
